import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Login from './components/Login';
import Dashboard from './components/Dashboard';
import ProtectedLayout from './components/ProtectedLayout';
import EmailDB from './components/EmailDB';
import JSON from './components/JSON';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/Login" element={<Login />} />

        {/* 🔒 Everything else inside ProtectedLayout */}
        <Route path="/*" element={
          <ProtectedLayout>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/Dashboard" element={<Dashboard />} />
              <Route path="/EmailDB" element={<EmailDB />} />
              <Route path="/JSON" element={<JSON />} />
            </Routes>
          </ProtectedLayout>
        } />
      </Routes>
    </Router>
  );
}

export default App;
